import type {ExplainerStep} from 'spreadsheet-import-wizard/finalize/Explainer';

export const MOLECULE_IMPORT_EXPLAINER_HEADER = 'After you click "Import"';

export const MOLECULE_IMPORT_EXPLAINER_STEPS: ReadonlyArray<ExplainerStep> = [
  {
    title: 'Entity creation',
    description:
      "We'll create each molecule in your upload as a new entity. We'll also automatically create the base molecule of any salts or solvates that reference a base molecule that doesn't exist in your organization.",
  },
  {
    title: 'Entity registration',
    description:
      'All successfully created entities will be registered into your organization\u2019s registry. You\u2019ll receive an email containing a summary of your import.',
  },
  {
    title: 'Error handling',
    description:
      'If any molecules failed to import, you\u2019ll also receive a summary containing the errors that prevented the import.',
  },
];
